import React from "react";
import { Phone, Mail, Instagram, MapPin } from "lucide-react";
import BackgroundRings from "../components/BackgroundRings";
import FadeIn from "../components/FadeIn";
import {
    WHATSAPP_URL,
    waUrl,
    PHONE_DISPLAY,
    EMAIL,
    INSTAGRAM,
    INSTAGRAM_URL,
} from "../lib/constants";

const Contact = () => {
    return (
        <main data-testid="contact-page">
            <section
                style={{
                    position: "relative",
                    minHeight: "100vh",
                    padding: "160px 32px 100px",
                    overflow: "hidden",
                    display: "flex",
                    alignItems: "center",
                }}
                data-testid="contact-hero"
            >
                <BackgroundRings opacity={0.08} position="right" />
                <div
                    style={{
                        maxWidth: 1200,
                        margin: "0 auto",
                        width: "100%",
                        position: "relative",
                        zIndex: 2,
                    }}
                >
                    <FadeIn>
                        <p className="eyebrow" style={{ marginBottom: 24 }}>
                            Contact
                        </p>
                        <h1
                            className="font-serif"
                            data-testid="contact-headline"
                            style={{
                                color: "#ffffff",
                                fontSize: "clamp(44px, 7vw, 96px)",
                                fontWeight: 400,
                                lineHeight: 1.02,
                                letterSpacing: "-0.02em",
                                marginBottom: 24,
                                maxWidth: 1100,
                            }}
                        >
                            Reserve your{" "}
                            <span style={{ color: "#c9a227" }}>
                                session.
                            </span>
                        </h1>
                        <p
                            style={{
                                color: "#a8a8a8",
                                fontSize: 20,
                                lineHeight: 1.6,
                                marginBottom: 48,
                                fontWeight: 300,
                            }}
                        >
                            Reserve your session via WhatsApp.
                        </p>
                        <a
                            href={waUrl(
                                "Hi Aditya, I'd like to reserve a session (from Contact page).",
                            )}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn-gold-solid"
                            data-testid="contact-whatsapp-cta"
                            style={{
                                fontSize: 14,
                                padding: "20px 40px",
                                minHeight: 60,
                            }}
                        >
                            Reserve via WhatsApp
                        </a>
                    </FadeIn>

                    <FadeIn delay={200}>
                        <div
                            style={{
                                marginTop: 96,
                                display: "grid",
                                gridTemplateColumns:
                                    "repeat(auto-fit, minmax(240px, 1fr))",
                                gap: 1,
                                backgroundColor: "rgba(201,162,39,0.12)",
                            }}
                        >
                            <a
                                href={WHATSAPP_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="contact-whatsapp-card"
                                style={{
                                    backgroundColor: "#0a0a0a",
                                    padding: "36px 28px",
                                    textDecoration: "none",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 12,
                                }}
                            >
                                <Phone size={22} color="#c9a227" />
                                <p
                                    className="eyebrow"
                                    style={{ margin: 0 }}
                                >
                                    WhatsApp
                                </p>
                                <p
                                    style={{
                                        color: "#ffffff",
                                        fontSize: 18,
                                        margin: 0,
                                        fontWeight: 300,
                                    }}
                                >
                                    {PHONE_DISPLAY}
                                </p>
                            </a>
                            <a
                                href={`mailto:${EMAIL}`}
                                data-testid="contact-email-card"
                                style={{
                                    backgroundColor: "#0a0a0a",
                                    padding: "36px 28px",
                                    textDecoration: "none",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 12,
                                }}
                            >
                                <Mail size={22} color="#c9a227" />
                                <p
                                    className="eyebrow"
                                    style={{ margin: 0 }}
                                >
                                    Email
                                </p>
                                <p
                                    style={{
                                        color: "#ffffff",
                                        fontSize: 14,
                                        margin: 0,
                                        fontWeight: 300,
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                    title={EMAIL}
                                >
                                    {EMAIL}
                                </p>
                            </a>
                            <a
                                href={INSTAGRAM_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="contact-instagram-card"
                                style={{
                                    backgroundColor: "#0a0a0a",
                                    padding: "36px 28px",
                                    textDecoration: "none",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 12,
                                }}
                            >
                                <Instagram size={22} color="#c9a227" />
                                <p
                                    className="eyebrow"
                                    style={{ margin: 0 }}
                                >
                                    Instagram
                                </p>
                                <p
                                    style={{
                                        color: "#ffffff",
                                        fontSize: 18,
                                        margin: 0,
                                        fontWeight: 300,
                                    }}
                                >
                                    {INSTAGRAM}
                                </p>
                            </a>
                            <div
                                data-testid="contact-location-card"
                                style={{
                                    backgroundColor: "#0a0a0a",
                                    padding: "36px 28px",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 12,
                                }}
                            >
                                <MapPin size={22} color="#c9a227" />
                                <p
                                    className="eyebrow"
                                    style={{ margin: 0 }}
                                >
                                    Locations
                                </p>
                                <p
                                    style={{
                                        color: "#ffffff",
                                        fontSize: 15,
                                        margin: 0,
                                        fontWeight: 300,
                                        lineHeight: 1.5,
                                    }}
                                >
                                    Al Hamra, Ras Al Khaimah
                                    <br />
                                    Al Furjan, Dubai
                                </p>
                            </div>
                        </div>
                    </FadeIn>
                </div>
            </section>
        </main>
    );
};

export default Contact;
